import styled from 'styled-components';
import { GatsbyImage } from "gatsby-plugin-image"

export const LaptopImg = styled(GatsbyImage)`
  width: 482px;
  height: 349px;
`;
